import MultiSelectPillList from './MultiSelectPillList'

export default MultiSelectPillList
